module.exports = __webpack_public_path__ + "img/quick-exit.2f2cba35.png";